const NavigationPopup = () => ({
  root: {
    [':style']() {
      return {
        background: `var(--col-${this.$store.navigation.popupBgColor})`,
        '--aa-input-background-color-rgb': `var(--col-${this.$store.navigation.popupBgColor});`
      };
    }
  },

  init() {
    this.$watch('$store.navigation.isOpen', (isOpen) => {
      if (isOpen) {
        this.$root.showModal();
      } else {
        this.$root.close();
      }
    });

    this.$root.addEventListener('close', () => {
      this.$store.navigation.isOpen = false;
    });
  }
});

export default NavigationPopup;
